import { mutatorAction } from 'satcheljs';
import { getFilesPreviewInformationStore } from '../store/FilesPreviewInformationStore';

export const clearFilesPreviewInformationAction = mutatorAction(
    'clearFilesPreviewInformationAction',
    function clearFilesPreviewInformationAction() {
        getFilesPreviewInformationStore().fileInformation = {};
    }
);
